import { WsmFeeBasis, WsmFeeScope, WsmOptionSetPromptType } from "@dashboard/graphql";

import { feeMessages, optionSetMessages } from "./messages";

/**
 * One place each enum is put into merchant words, so a list cell and the select
 * on the form that edits it can never drift apart.
 */
export const promptTypeLabels = {
  [WsmOptionSetPromptType.CHOICE_ONE]: optionSetMessages.promptChoiceOne,
  [WsmOptionSetPromptType.CHOICE_MANY]: optionSetMessages.promptChoiceMany,
  [WsmOptionSetPromptType.TEXT]: optionSetMessages.promptText,
  [WsmOptionSetPromptType.DATE]: optionSetMessages.promptDate,
  [WsmOptionSetPromptType.DATETIME]: optionSetMessages.promptDatetime,
  [WsmOptionSetPromptType.IMAGE]: optionSetMessages.promptImage,
};

export const getPromptTypeLabel = (promptType: WsmOptionSetPromptType) =>
  promptTypeLabels[promptType];

export const feeBasisLabels = {
  [WsmFeeBasis.FIXED]: feeMessages.basisFixed,
  [WsmFeeBasis.PERCENT]: feeMessages.basisPercent,
};

export const getFeeBasisLabel = (basis: WsmFeeBasis) => feeBasisLabels[basis];

export const feeScopeLabels = {
  [WsmFeeScope.PER_UNIT]: feeMessages.scopePerUnit,
  [WsmFeeScope.PER_LINE]: feeMessages.scopePerLine,
};

export const getFeeScopeLabel = (applyTo: WsmFeeScope) => feeScopeLabels[applyTo];
